import { type Event, createEffect, sample } from 'effector';

const delay = <T>(options: { source: Event<T>; timeout: number }): Event<T> => {
    const { source, timeout } = options;
    const sleep = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));
    const target = createEffect<T, T>(async (params) => {
        await sleep(timeout);
        return params;
    });
    sample({ source, target });
    return target.doneData;
};

export default delay;
